"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/VideoCall/Modals/Settings.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _videoCall = require('web/selectors/videoCall');
var _videoRoom = require('web/selectors/videoRoom');
var _hooks = require('web/services/hooks');
var _Modals = require('web/components/VideoCall/Modals');
var _videoRoom3 = require('web/services/videoRoom'); var _videoRoom4 = _interopRequireDefault(_videoRoom3);








// Was a class inside connect(): memo keeps connect's props bail-out. The
// problem handler keeps a stable identity (the modal hands it to the memoised
// setup groups, as the class method was) and reads the latest room key, like
// `this.props`; the close handler goes to the modal only (not memoised).
const SettingsModalContainer = ({ isOpen, onClose, context }) => {
  const roomKey = _hooks.useAppSelector.call(void 0, _videoRoom.selectCurrentVideoRoomKey)
  // Not rendered, but connect() subscribed to them, so a device change
  // re-renders the modal as before.
  _hooks.useAppSelector.call(void 0, _videoCall.selectCurrentMicDeviceId)
  _hooks.useAppSelector.call(void 0, _videoCall.selectCurrentCamDeviceId)

  const latestRoomKey = _react.useRef.call(void 0, roomKey)
  _react.useLayoutEffect.call(void 0, () => { latestRoomKey.current = roomKey })

  const handleUserProblemPublish = _react.useCallback.call(void 0, (e) => {
    const session = _videoRoom4.default.findByRoomKey(latestRoomKey.current)
    if (!session) return
    // Existing behaviour kept: publishProblem takes `{ origin }`, but this
    // passes the bare origin string, so the problem code sent is undefined.
    const origin = e.origin
    // SAFETY: the cast only restates what the JS passed.
    session.publishProblem(origin )
  }, [])

  const handleClose = () => {
    if (context && context.cb) context.cb()
    onClose()
  }

  if (!isOpen) return null

  return (
    _react2.default.createElement(_Modals.SettingsModal, {
      isOpen: isOpen,
      onClose: handleClose,
      onUserProblemPublish: handleUserProblemPublish, __self: this, __source: {fileName: _jsxFileName, lineNumber: 47}}
    )
  )
}

exports. default = _react.memo.call(void 0, SettingsModalContainer)
